// extracted by mini-css-extract-plugin
export default {"heading":"SignIn_heading__BDgiA","heading_div":"SignIn_heading_div__jIEL6","linkStyle":"SignIn_linkStyle__iVl7S","lastUsedLwaButton":"SignIn_lastUsedLwaButton__iYTHG"};